export default __webpack_public_path__ + "static/media/youtube-thumbnail.dbceb2b5.jpeg";